import { connect } from 'react-redux';
import { deleteRole } from '../../../../redux/actions/roles&permissions/roles';
import { showToast } from '../../../../redux/actions/toasts';
import Delete from './Delete';

const mapDispatchToProps = (dispatch) => ({
  deleteRole: (roleId) => dispatch(deleteRole(roleId)),
  showToast: (message) => dispatch(showToast({ message })),
});

export default connect(null, mapDispatchToProps)(Delete);
